// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://apmnhnunfrcbydwysfez.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFwbW5obnVuZnJjYnlkd3lzZmV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3NTg3MjAsImV4cCI6MjA3MzMzNDcyMH0._6Rb9fMH3NB5rVElNAXaa3djas5mccVIGFO18DAlroY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});